import config from '@/config/config.js';
import { http } from '@/common/request';
import errorCode from '@/api/error-code.js'
export default {
    /***************************************************** start *******************************************/






    filterUserFounds(filter){
        let params = filter
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/funds/filterFunds",data, method: 'GET', ...options});
    },


    addFinanceAccountRecord(data){
        let params = {}
        // let data = {
        // }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/funds/addFinanceAccountRecord",data, method: 'POST', ...options});
    },


    financeAccountRecordDetail(recordId){
        let params = {}
        let data = {
        }
        params.recordId = recordId;
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/funds/financeAccountRecordDetail",data, method: 'GET', ...options});
    },
    userFinanceAccountRecordList(filter){
        let params = filter
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/funds/userFinanceAccountRecordList",data, method: 'GET', ...options});
    },

    financeReceivingAccount(){
        let params = {}
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/funds/getReceivingAccount",data, method: 'GET', ...options});
    },





    /***************************************************** end *********************************************/
}
